import {useQuery} from "@apollo/client";

import {
    VoucherClearingListResponse,
    GET_VOUCHER_CLEARING_LISTING
} from "../graphql/queries/getSettlementVoucherList";


import {useEffect, useState} from "react";
import {formatTimeRangeToISO} from "../../../../utils/dateTimeUtils";
import {VoucherClearingFilterType, VoucherClearingType} from "../graphql/types/VoucherClearingType";

export interface VoucherClearingQueryResult {
    voucherClearingData: VoucherClearingType[];
    loading: boolean;
    refetch: (variables?: any) => Promise<any>;
    totalElements: number;
    buildQueryVariables: () => any;
}

export const useVoucherClearingQuery = (
    filters: VoucherClearingFilterType,
    currentPage: number,
    pageSize: number,
    enabled: boolean = true
): VoucherClearingQueryResult => {
    const [voucherClearingData, setVoucherClearingData] = useState<VoucherClearingType[]>([]);
    const [loading, setLoading] = useState(!enabled);
    const [total, setTotal] = useState(0);

    const buildQueryVariables = () => {
        const timeRanges = {
            businessId: filters.businessId,
            otherBusinessId: filters.otherBusinessId,
            businessTime: formatTimeRangeToISO(filters.businessTime),
            settlementTime: formatTimeRangeToISO(filters.settlementTime),
            voucherClearStatus: filters.voucherClearStatus,
            settlementClientId: filters.settlementClientId,
            settlementItemCode: filters.settlementItemCode,
            userType: filters.userType,
        };

        const queryFilters = {
            ...filters,
            ...timeRanges
        };

        return {
            filters: queryFilters,
            pageRequest: {
                page: currentPage,
                size: pageSize,
                sortBy: "id",
                sortDirection: "DESC"
            }
        };
    };

    // 执行查询
    const { data, loading: queryLoading, refetch } = useQuery<VoucherClearingListResponse>(
        GET_VOUCHER_CLEARING_LISTING,
        {
            variables: buildQueryVariables(),
            skip: !enabled
        }
    );

    useEffect(() => {
        if (!enabled) {
            setVoucherClearingData([]);
            setTotal(0);
            setLoading(false);
            return;
        }

        // 启用查询后，先进入 loading 状态，等待 data 回来
        setLoading(true);
    }, [enabled]);

    // 当数据变化时更新状态
    useEffect(() => {
        const responseData = data?.getVoucherClearingPageable?.content;
        if (responseData) {
            setVoucherClearingData(responseData);
            setLoading(false);
        }
        const rawTotal = data?.getVoucherClearingPageable?.totalElements;
        if (rawTotal !== undefined && rawTotal !== null) {
            const n = Number(rawTotal);
            if (Number.isFinite(n)) {
                setTotal(Math.max(0, Math.trunc(n)));
            }
        }
    }, [data]);

    return {
        voucherClearingData,
        loading: loading || queryLoading,
        refetch,
        totalElements: total,
        buildQueryVariables
    };
}; 